// Centralized feature flags for Coding Board customizations of scratch-gui.
// Disabled flags hide community-facing Scratch features without removing
// their code, simplifying upstream syncs.
export const CODING_BOARD_FLAGS = {
    ENABLE_SCRATCH_COMMUNITY: false, // "Join Scratch" / "Sign in" links
    ENABLE_BACKPACK: false, // Backpack feature
    ENABLE_COMMUNITY_BUTTON: false, // "See community" button
    ENABLE_SHARE_TO_SCRATCH: false, // Share to scratch.mit.edu
    ENABLE_SCRATCH_TUTORIALS_LINK: false, // External tutorials linking to scratch.mit.edu
    ENABLE_TUTORIALS_LIBRARY: true, // Internal tutorial library (keep)
    SHOW_PLACEHOLDER_LOGIN: true // Show "Iniciar sesión" placeholder
};
